import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OutletIcon(props: IconProps) {
    return <Icon {...props} iconKey={"outlet"}/>
}
